import axios from "./axios";

export const getTraders = async () => {
  const response = await axios.get("/users/traders/");
  return response.data;
};

export const createTraders = async (payload) => {
  const response = await axios.post("/users/traders/", payload);
  return response.data;
};

export const createTrader = createTraders;

export const editTraders = async (id, payload) => {
  const response = await axios.put(`/users/traders/${id}/`, payload);
  return response.data;
};

export const updateTrader = editTraders;

export const deleteTraders = async (id) => {
  const response = await axios.delete(`/users/traders/${id}/`);
  return response.data;
};

export const deleteTrader = deleteTraders;

/** PUT — singular `trader` in path per backend */
export const changeTraderPassword = async (id, payload) => {
  const response = await axios.put(`/api/users/trader/${id}/change-password/`, payload);
  return response.data;
};
